import FieldWithDateValueController from '../fieldWithDateValue.controller';

class DateFieldController extends FieldWithDateValueController {
  constructor($scope, $q, $translate, $log, $timeout, DateTimeService, LogService) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout, DateTimeService, LogService);
    this.DateTimeService = DateTimeService;
    this._datePickerOpened = false;
    this._datePickerOptions = {};
  }

  $onInit() {
    super.$onInit();
  }

  get datePickerOptions() {
    return this._datePickerOptions;
  }

  get datePickerOpened() {
    return this._datePickerOpened;
  }

  set datePickerOpened(opened) {
    this._datePickerOpened = opened;
  }

  openDatePicker(event) {
    this._datePickerOpened = true;
  }

  closeDatePicker() {
    this._datePickerOpened = false;
  }
}

export default DateFieldController;
